import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { K } from '../apiServiceI18n';

const STYLES = {
  enabled: { bgcolor: '#e3f2fd', color: '#1565c0', border: '1px solid #90caf9' },
  disabled: { bgcolor: '#eceff1', color: '#546e7a', border: '1px solid #cfd8dc' },
};

export default function ApiServiceStatusChip({ status }) {
  const { t } = useTranslation();
  const isEnabled = status === 'enabled';
  const label = isEnabled ? t(K.API_SVC_CHIP_ENABLED) : t(K.API_SVC_CHIP_DISABLED);

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 24,
        ...(STYLES[isEnabled ? 'enabled' : 'disabled']),
      }}
    />
  );
}
